import React, { useLayoutEffect, useState } from 'react';
import { Col, Flex, Row, Skeleton } from 'antd';
import { Image } from 'antd';
import { Carousel } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Card } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getContentDetail, getDashboard } from '../../store/slices/home';
import { Config } from '../../utils/config';
import './styles.css';

const HomeScreen = () => {
    const dispatch = useDispatch();
    const [content, setContent] = useState({ banners: [] });
    const [rows, setRows] = useState([]);
    const loading = useSelector((state) => state.home.loading);
    let navigate = useNavigate();
    const getContent = () => {
        dispatch(getDashboard()).unwrap().then(result => {
            if (result) {
                setRows(result?.events.reduce((acc, item, index) => {
                    const chunkIndex = Math.floor(index / 3);
                    if (!acc[chunkIndex]) {
                        acc[chunkIndex] = []; // start a new chunk
                    }

                    acc[chunkIndex].push(item);

                    return acc;
                }, []))
                setContent(result);
            }
            else {
                setContent({ banners: [] })
                setRows([])
            }
        })
    }


    useLayoutEffect(() => {
        getContent();
    }, []);

    return (
        <>
            {loading ? (<Skeleton />) :
                (
                    <Col span={24}>
                        <Carousel autoplay autoplaySpeed={5000} arrows style={{ padding: 10 }} dotPosition='bottom' >
                            {content?.banners.map((item, index) => (
                                <div>
                                    <Image
                                        key={index}
                                        preview={false}
                                        src={Config.CDN_URL + item}
                                    />
                                </div>
                            ))}
                        </Carousel>

                        <Flex justify='center' align='center' vertical gap={'large'} style={{ paddingTop: 30, marginBottom: 5  }}>
                            {rows.map((item, index) => (
                                <Row gutter={10} key={index}>
                                    {item.map((col, colIndex) => (
                                        <Col key={colIndex}>
                                            <Card
                                                onClick={() => {
                                                    dispatch(getContentDetail(col.name)).unwrap().then(result => {
                                                        if (result)
                                                            navigate('/CardDetailPage', { state: { data: result } });
                                                    })
                                                }}
                                                hoverable
                                                className="custom-card"
                                                style={{
                                                    width: 240,
                                                }}
                                                title={
                                                    <div style={{
                                                        textAlign: 'center',
                                                        wordBreak: 'break-word',
                                                        whiteSpace: 'normal'
                                                    }}>
                                                        {col.name}
                                                    </div>
                                                }
                                                cover={<img alt="example" src={Config.CDN_URL + col.coverImage} />}
                                            />
                                        </Col>
                                    ))}
                                </Row>
                            ))}


                        </Flex>
                    </Col>
                )}

        </>
    );
};
export default HomeScreen;